import { Activity } from "lucide-react";
import { PdfChip } from "./PdfChip";
import { SignalMesh } from "./SignalMesh";
import bgLogo from "../../assets/bg.svg";

type PdfCoverProps = {
  companyName?: string;
};

/** A4 cover / intro — single branding block, balanced layout */
export function PdfCover({ companyName }: PdfCoverProps) {
  const org = companyName?.trim() || "Your Organization";

  return (
    <div className="pdf-cover flex h-full flex-col">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2.5">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-dark">
            <Activity className="h-4 w-4 text-signal" strokeWidth={2.5} />
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold tracking-tight">Signal AI</span>
            <span className="inline-flex items-center gap-0">
              <span className="text-[10px] font-medium text-muted-foreground">by</span>
              <img src={bgLogo} alt="Gowitek" className="h-5 w-auto object-contain" />
            </span>
          </div>
        </div>
        <PdfChip size="sm">Confidential · Executive Brief</PdfChip>
      </div>

      <div className="pdf-cover__center relative my-auto flex flex-1 flex-col items-center justify-center text-center">
        <SignalMesh className="pdf-cover__mesh pointer-events-none absolute inset-0 h-full w-full opacity-85" />
        <PdfChip size="sm" className="relative mb-5">Executive Report</PdfChip>
        <h1 className="pdf-cover__title report-h1 relative w-full">
          <span className="block">Executive</span>
          <span className="pdf-accent block">AI Readiness</span>
          <span className="block">Assessment</span>
        </h1>
        <p className="report-body relative mt-5 max-w-md">
          Assessment of AI readiness, operational gaps, and opportunities for ROI improvement.
        </p>
        <p className="relative mt-8 text-xl font-semibold tracking-tight text-foreground/90">{org}</p>
      </div>

      <p className="report-caption text-center text-foreground/50">
        Gowitek Signal AI · AI Readiness Assessment
      </p>
    </div>
  );
}
